import { Phone, MapPin, MessageSquare } from 'lucide-react';
import { config } from '../../lib/config';

function CompanyInfo() {
  const { contact } = config.company;

  // Format phone number for WhatsApp link
  const whatsappNumber = contact.phone.replace(/\D/g, '');
  const whatsappLink = `https://wa.me/55${whatsappNumber}`;

  // Format address in a single line
  const fullAddress = `${contact.address.street}, ${contact.address.number} - ${contact.address.neighborhood}, ${contact.address.city} - ${contact.address.state}, ${contact.address.zipCode}`;

  return (
    <div className="space-y-6 text-primary-100 dark:text-gray-300">
      {/* Highlighted Phone/WhatsApp Section */}
      <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
        <div className="flex items-center gap-3 mb-2">
          <Phone className="h-6 w-6 text-green-400" />
          <h3 className="text-lg font-semibold text-white">Fale Conosco</h3>
        </div>
        <div className="flex items-center gap-4">
          <a 
            href={`tel:${whatsappNumber}`} 
            className="text-xl font-bold text-white hover:text-green-400 transition-colors"
          >
            {contact.phone}
          </a>
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-full transition-colors"
            title="Abrir WhatsApp"
          >
            <MessageSquare className="h-5 w-5" />
            <span className="font-medium">WhatsApp</span>
          </a>
        </div>
      </div>

      <div className="flex items-center space-x-2 pl-2">
        <MapPin className="h-5 w-5 flex-shrink-0" />
        <address className="not-italic text-sm">
          {fullAddress}
        </address>
      </div>
    </div>
  );
}

export default CompanyInfo;